import { Avatar } from "@tokenterminal/core/ui/icon/Avatar"
import { toDictionary } from "@tokenterminal/core/utils/toDictionary"
import { useChainsList } from "modules/projects/hooks/useChainsList"
import { useMemo } from "react"

const SingleChainDisplay = ({ chainId }: { chainId: string }) => {
  const { data: { data: chainsMetadata = [] } = {} } = useChainsList()
  const chainsById = useMemo(
    () => toDictionary(chainsMetadata, "chain_id"),
    [chainsMetadata]
  )

  const chain = useMemo(() => {
    return chainsById.get(chainId)
  }, [chainId, chainsById])

  if (!chain) {
    return null
  }

  return (
    <div className="flex items-center gap-2 text-fg-secondary">
      <Avatar
        src={`https://static1.tokenterminal.com/${chain.logo}`}
        className="w-4 h-4 rounded-full overflow-hidden flex-shrink-0"
      />
      {chain.name}
    </div>
  )
}

export default SingleChainDisplay
